import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { supportedPublicLanguages } from 'academy-common-lib/constants/academySupportedLanguages';
import { List } from 'foundations-components/transitional/components/List';
import { LanguageIcon } from 'foundations-assets';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { ThemedDropdown } from '../../../components/ThemedComponents';
import { Link } from 'foundations-components/transitional/components/Link';
import { useMemo } from 'react';
import { getPublicLang, getPublicUrlLanguageVariant, getSingleLanguageVariantUrl } from 'academy-common-lib/utils/url';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublicLanguageDropdown = ({
  options = supportedPublicLanguages,
  href = window.location.href,
  languageLinkedContent,
  contentType,
  pagePath
}) => {
  const appLanguage = getPublicLang();
  const availableLanguages = useMemo(() => {
    if (languageLinkedContent !== null && languageLinkedContent !== void 0 && languageLinkedContent.languageToPagePath) {
      const linkedLanguages = Object.keys(languageLinkedContent.languageToPagePath);
      return [...new Set([appLanguage, ...linkedLanguages])];
    }
    return options;
  }, [languageLinkedContent, options, appLanguage]);
  const sortedLanguages = useMemo(() => [...availableLanguages].sort(), [availableLanguages]);
  const getLanguageUrl = language => {
    const isSingleLanguageVariant = contentType && pagePath && (languageLinkedContent === null || languageLinkedContent === void 0 ? void 0 : languageLinkedContent.languageToPagePath) && language in languageLinkedContent.languageToPagePath;
    const languagePagePath = languageLinkedContent === null || languageLinkedContent === void 0 ? void 0 : languageLinkedContent.languageToPagePath[language];
    if (isSingleLanguageVariant && languagePagePath) {
      return getSingleLanguageVariantUrl({
        pagePath: languagePagePath,
        contentType,
        language,
        href
      });
    }
    return getPublicUrlLanguageVariant(href, language);
  };
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    children: [/*#__PURE__*/_jsx(IconHolder, {
      color: "icon-core-subtle",
      icon: LanguageIcon,
      marginInlineStart: "-200",
      padding: "0",
      size: "600"
    }), /*#__PURE__*/_jsx(ThemedDropdown, {
      buttonText: LanguageNames[appLanguage],
      buttonUse: "transparent",
      paddingInline: "300",
      children: /*#__PURE__*/_jsx(List, {
        wrapChildren: true,
        children: sortedLanguages.map(language => /*#__PURE__*/_jsx(Link, {
          href: getLanguageUrl(language),
          children: LanguageNames[language]
        }, language))
      })
    })]
  });
};
export default PublicLanguageDropdown;